export class Photo {
    id!: number;
    fileName!: string;

    public constructor(init?:Partial<Photo>) {
        Object.assign(this, init);
    }
}
